import { render, staticRenderFns } from "./CompanyCreateCard.vue?vue&type=template&id=6f4001f7&"
import script from "./CompanyCreateCard.vue?vue&type=script&lang=ts&"
export * from "./CompanyCreateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4001f7')) {
      api.createRecord('6f4001f7', component.options)
    } else {
      api.reload('6f4001f7', component.options)
    }
    module.hot.accept("./CompanyCreateCard.vue?vue&type=template&id=6f4001f7&", function () {
      api.rerender('6f4001f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyCreateCard.vue"
export default component.exports